import classNames from 'classnames';
import { useState } from 'react';

import styles from './FormText.module.scss';
import { FormTextProps } from './types';

export function FormText({
  id,
  name,
  placeholder,
  value,
  readOnly,
  required,
  disabled,
  isError,
  label,
  rows,
  onChange,
  onBlur = () => undefined,
}: FormTextProps) {
  const [isFocus, setIsFocus] = useState(false);

  return (
    <div className={classNames(styles.inputContainer)}>
      {label && (
        <label className={classNames(styles.label)}>
          {label}
          {required && <i className={styles.required}>*</i>}
        </label>
      )}
      <textarea
        id={id}
        name={name}
        placeholder={placeholder}
        readOnly={readOnly}
        required={required}
        disabled={disabled}
        onChange={onChange}
        value={value}
        rows={rows}
        onFocus={() => setIsFocus(true)}
        onBlur={(event) => {
          onBlur(event);
          setIsFocus(false);
        }}
        className={classNames(styles.input, {
          [styles.isError]: isError,
          [styles.isFocus]: isFocus,
        })}
      />
      {required && !label && <i className={styles.required}>*</i>}
    </div>
  );
}
